var map = {
	"./actions.svg": 66366,
	"./activity.svg": 19290,
	"./add.svg": 19830,
	"./alcohol.svg": 6949,
	"./alert.svg": 92177,
	"./archive.svg": 61437,
	"./article.svg": 74781,
	"./audio.svg": 68857,
	"./back.svg": 28216,
	"./balance.svg": 46599,
	"./bereavment.svg": 21084,
	"./business.svg": 40899,
	"./button/back-off.svg": 46317,
	"./button/back.svg": 49753,
	"./button/next-off.svg": 88051,
	"./button/next.svg": 48843,
	"./button/secondary/next-off.svg": 69410,
	"./button/secondary/next.svg": 11122,
	"./caffeine.svg": 34260,
	"./chart.svg": 63363,
	"./children.svg": 60440,
	"./close.svg": 90495,
	"./commuting.svg": 91794,
	"./compare.svg": 7066,
	"./confirm.svg": 92931,
	"./crime.svg": 52625,
	"./delete.svg": 48124,
	"./down.svg": 21353,
	"./download.svg": 53353,
	"./edit.svg": 1361,
	"./empty.svg": 35964,
	"./family.svg": 48485,
	"./filter.svg": 23251,
	"./flag.svg": 22811,
	"./go.svg": 4095,
	"./health.svg": 36531,
	"./help.svg": 20876,
	"./house.svg": 73955,
	"./illness.svg": 52915,
	"./job.svg": 35797,
	"./left-70.svg": 14770,
	"./left.svg": 1426,
	"./leisure.svg": 1382,
	"./life.svg": 88015,
	"./message/error.svg": 43734,
	"./message/success.svg": 60794,
	"./money.svg": 89567,
	"./more.svg": 48422,
	"./nutrition.svg": 21567,
	"./order.svg": 93259,
	"./person.svg": 37086,
	"./piechart.svg": 34111,
	"./relationship.svg": 36959,
	"./relaxation.svg": 88388,
	"./remove.svg": 27521,
	"./report-combine.svg": 3695,
	"./report.svg": 69480,
	"./resilience.svg": 45170,
	"./right.svg": 34985,
	"./search.svg": 35325,
	"./sleep.svg": 54270,
	"./tick.svg": 23978,
	"./time.svg": 81226,
	"./unavailable.svg": 25753,
	"./unemployed.svg": 19201,
	"./upload.svg": 95550,
	"./userhead.svg": 73034,
	"./video.svg": 79294,
	"./view.svg": 31750,
	"./waiting.svg": 63238,
	"./weight.svg": 55385,
	"./white/account.svg": 59740,
	"./white/add.svg": 31156,
	"./white/back-70.svg": 88198,
	"./white/back.svg": 40734,
	"./white/left.svg": 67664,
	"./white/right-70.svg": 14501,
	"./white/right.svg": 41055,
	"./white/time.svg": 76420,
	"./zap.svg": 65933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68401;